import {Switch} from '@wandb/weave/components';
import React, {FC, useState} from 'react';

import {SettingTitle} from '../common/SettingTitle';
import {MediaSettingProps} from '../types';

export const GridMode: FC<MediaSettingProps> = ({config, updateConfig}) => {
  const [mode, setMode] = useState(config.mode);
  const isChecked = mode === 'grid';

  return (
    <div className="flex justify-between">
      <SettingTitle title="Grid mode" />
      <Switch.Root
        data-test="grid-mode-switch"
        checked={isChecked}
        onCheckedChange={newIsChecked => {
          const newMode = newIsChecked ? 'grid' : 'gallery';
          setMode(newMode);
          updateConfig({mode: newMode});
        }}>
        <Switch.Thumb checked={isChecked} />
      </Switch.Root>
    </div>
  );
};
